import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../common/Button";
import useAnalyticsContext from "../../hooks/useAnalyticsContext.js";
import {
  trackCTA,
  trackSectionViewed,
  useSectionOnceObserver,
} from "../../lib/analytics";
import { WPS_SECTION } from "./sections.js";
import useLocalizedHref from "../../hooks/useLocalizedHref.js";

/**
 * Closing statement.
 *
 * Deliberately NOT the shared `CtaSection` used by Home and Contact: that
 * component is a bare arc + link that points into the signup flow, and this
 * page's closing CTA carries a heading and a line of copy and points at the
 * homepage. Reusing it would have meant passing markup it has no slot for.
 *
 * `trackLead` is not fired here. Lead is reserved for CTAs that carry real
 * signup intent (destination is the create-event flow); this one sends the
 * visitor deeper into the marketing site, so it is a CTA click and nothing more.
 */
const PhotoSharingFinalCta = () => {
  const { t } = useTranslation();
  const localize = useLocalizedHref();
  const analyticsContext = useAnalyticsContext();

  // Impression for the close, so the CTA's clicks have a denominator.
  const sectionRef = useSectionOnceObserver(() =>
    trackSectionViewed(WPS_SECTION.FINAL_CTA, analyticsContext),
  );

  return (
    <section ref={sectionRef} className="section wps-section wps-final">
      <div className="container">
        <div className="wps-final-inner">
          <h2 className="heading-136">
            {t("weddingPhotoSharing.finalCta.heading")}
          </h2>
          <p className="body-20 wps-final-body">
            {t("weddingPhotoSharing.finalCta.body")}
          </p>
          <Button
            href={localize("/")}
            text={t("weddingPhotoSharing.finalCta.cta")}
            className="button-lg"
            onClick={() =>
              trackCTA("wedding_photo_sharing_final_cta", {
                ...analyticsContext,
                ctaName: "discover_agapae",
              })
            }
          />
        </div>
      </div>
    </section>
  );
};

export default PhotoSharingFinalCta;
